import axios from 'axios';
import cfac22 from '../../cfac22';

export const getPreData = async ({ partnerId, identifier }) => {
  if (!partnerId || !identifier) return {};

  try {
    const { data } = await axios.post(
      `${cfac22('MICROSERVICES')}/auth/predata`,
      { partnerId, identifier },
      { withCredentials: true, headers: { 'Full-Url': window.location.href } }
    );
    const preData = data?.result?.preData ?? data?.data;
    return preData && typeof preData === 'object' ? preData : {};
  } catch {
    return {};
  }
};
